export default __webpack_public_path__ + "media/Dry-Food-Other.26a0f944.png";